import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="phone"
export default class extends Controller {
  static targets = ['button', 'input'];
  declare buttonTarget: HTMLButtonElement;
  declare inputTarget: HTMLInputElement;

  connect(): void {
    this.inputTarget.addEventListener('input', this.#change);
    this.#updateDisableButton(true);
  }

  disconnect(): void {
    this.inputTarget.removeEventListener('input', this.#change);
    this.#updateDisableButton(false);
  }

  #change: () => void = () => {
    this.#updateDisableButton(this.inputTarget.value.length === 0);
  };

  #updateDisableButton: (value: boolean) => void = (value) => {
    this.buttonTarget.disabled = value;
  };
}
